export default "__VITE_ASSET__DdbJSbDe__"